import { useTheme } from '@mui/material';
import { DoorBatteryWarningLevel } from 'graphql/generated/graphqlTypes';
import useBatteryStatusUI from 'hooks/useBatteryStatusUI/useBatteryStatusUI';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import styled from 'styled-components';
import Typography from 'ui/atoms/Typography/Typography';
import Icon from '../Icon/Icon';

export interface CssProps {
  flex?: string;
}
export interface Props extends CssProps {
  status: DoorBatteryWarningLevel;
  id?: string;
}

const TableCellWrapper = styled.div<Partial<CssProps>>`
  display: flex;
  flex-direction: row;
  min-width: 0;
  gap: 0.5rem;
  align-items: center;
  ${({ flex }) => flex && `flex: ${flex}`};
`;

interface IconWrapperProps {
  opacity: null | string;
}

const IconWrapper = styled.div<IconWrapperProps>`
  align-items: center;
  justify-content: center;
  opacity: ${({ opacity }) => opacity};
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
`;

const BatteryStatusCell: React.FC<React.PropsWithChildren<Props>> = ({ status, flex, id }) => {
  const theme = useTheme();
  const { translation } = useTranslation();
  const { getBatteryData } = useBatteryStatusUI(translation);

  return (
    <TableCellWrapper flex={flex} id={id}>
      <IconWrapper opacity={getBatteryData(status, theme).iconOpacity}>
        <Icon
          name={getBatteryData(status, theme).iconName}
          color={getBatteryData(status, theme).iconColor}
          id={`${id}-icon`}
        />
      </IconWrapper>
      <Typography variant="body4" color="lTextMedium" id={`${id}-text`}>
        {getBatteryData(status, theme).CellText}
      </Typography>
    </TableCellWrapper>
  );
};

export default BatteryStatusCell;
